import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { apiError } from "@/context/AuthContext";
import { toast } from "sonner";
import AuthLayout, { Field, SubmitButton } from "@/pages/AuthLayout";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (e2) { setError(apiError(e2.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <AuthLayout title="Choose a new password" subtitle="Enter a new password for your account.">
      {!token ? (
        <div className="rounded-xl border border-red-200 bg-red-50 p-5 text-sm text-red-700">
          Invalid reset link. <Link to="/forgot-password" className="underline font-medium">Request a new one</Link>.
        </div>
      ) : (
        <form onSubmit={submit} data-testid="reset-form">
          <Field label="New password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" placeholder="At least 6 characters" />
          {error && <p className="text-sm text-red-600 mb-3">{error}</p>}
          <SubmitButton loading={loading} type="submit" data-testid="reset-submit">Update password</SubmitButton>
        </form>
      )}
    </AuthLayout>
  );
}
